<template>
  <div class="noema-wrapper">
    <!-- 通知类 -->
    <div
      v-if="mindData.notify"
      class="noema-section"
    >
      <img
        :src="mindData.notify.icon"
        class="icon"
      />
      <vertical-scroll :list-data="mindData.notify.list" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'Noema',

  components: {
    VerticalScroll: () => import(/* webpackChunkName: 'notify-scroll' */ './VerticalScroll.vue'),
  },

  props: {
    mindData: {
      default: () => ({} as MindType),
      type: Object as () => MindType,
    },
  },
});
</script>

<style lang="less" scoped>
.noema-wrapper {
  background: #fff;
  border-radius: 0.12rem;
  padding: 0 0.24rem;
  overflow: hidden;
}
</style>
